import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { PageHeader, CustomPanel, CustomDropdown, SectionTitle } from '../../../../components'
import useCicloEntregaAcoesState, {
  ACAO_TELA_SELECIONADA,
  TIPOS_ACOES_CICLO_ENTREGA,
} from './CicloEntregaAcoesState'
import EnvioEmail from './EnvioEmail/EnvioEmail'
import ExportProgramacaoExcel from './ExportProgramacaoExcel/ExportProgramacaoExcel'
import RevisaoDataProgramacao from './RevisaoDataProgramacao/RevisaoDataProgramacao'
import PlacaPrevistaCarregamento from './PlacaPrevistaCarregamento/PlacaPrevistaCarregamento'
import CicloAlteracaoQuantidades from './CicloAlteracaoQuantidades/CicloAlteracaoQuantidades'
import EspelhoNota from './EspelhoNota/EspelhoNota'
import GerarCrossRecebimento from './GerarCrossRecebimento/GerarCrossRecebimento'
import AssociarXmls from './AssociarXmls/AssociarXmls'
import BaixarCanhotos from './BaixaCanhotos/BaixarCanhotos'
import EntradaSIF from './EntradaSIF/EntradaSIF'
import MapaPesoCidade from './MapaPesoCidade/MapaPesoCidade'
import EtiquetagemVolumes from './EtiquetagemVolumes/EtiquetagemVolumes'

export default connect()(withRouter(CicloEntregaAcoes))

function CicloEntregaAcoes({ history, dispatch }) {
  const ciclo = history.location.state.ciclo
  const central_operacional_id = history.location.state.central_operacional_id

  const { acaoSelecionada, telaSelecionada, onDropdownChange } = useCicloEntregaAcoesState(ciclo)

  // Helper
  function getTelaSelecionada() {
    switch (telaSelecionada) {
      case ACAO_TELA_SELECIONADA.ENVIO_EMAIL:
        return <EnvioEmail ciclo={ciclo} operationCenterId={central_operacional_id} />
      case ACAO_TELA_SELECIONADA.EXPORT_EXCEL_PROGRAMACAO:
        return <ExportProgramacaoExcel ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.REVISAO_PROGRAMACAO_CARGA:
        return <RevisaoDataProgramacao ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.PLACA_PREVISAO_CARREGAMENTO:
        return <PlacaPrevistaCarregamento ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.ALTERACAO_QTE:
        return <CicloAlteracaoQuantidades ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.ESPELHO_ENTREGAS:
        return <EspelhoNota ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.GERAR_CROSS_RECEBIMENTO:
        return <GerarCrossRecebimento ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.ASSOCIAR_XMLS:
        return <AssociarXmls ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.BAIXAR_CANHOTOS:
        return <BaixarCanhotos ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.ENTRADA_SIF:
        return <EntradaSIF ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.MAPA_PESO_CIDADE:
        return <MapaPesoCidade ciclo={ciclo} />
      case ACAO_TELA_SELECIONADA.ETIQUETAGEM_VOLUMES:
        return <EtiquetagemVolumes ciclo={ciclo} />
      default:
        return null
    }
  }

  // Render
  return (
    <>
      <PageHeader>
        Ciclos de Entrega &nbsp; <strong>Ações</strong> <strong> - {ciclo.name}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <SectionTitle title="Listagem das Ações Disponíveis" />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                label="Selecione a Ação Desejada"
                options={TIPOS_ACOES_CICLO_ENTREGA}
                value={acaoSelecionada}
                onChange={value => onDropdownChange(value)}
              />
            </div>
            <div className="p-col-12">{getTelaSelecionada()}</div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}
